/* ms-subir.js — boton de volver arriba. 2026-09-06

   Encargo, literal:
     flecha arriba dentro de un circulo pequeno; esquina inferior
     IZQUIERDA, porque WhatsApp ocupa la derecha; aparece solo despues
     de 600-800 px; al pulsarla vuelve suavemente al principio; 44x44
     minimo para el dedo; sin texto y sin animaciones continuas.

   ESPEJO DE WHATSAPP. Leidas las reglas reales de .modo-wa-float en la
   tienda el 2026-09-06. Aquel boton NO tiene una sola posicion, tiene
   dos, y en el primer intento copie solo la de movil:

     escritorio ... derecha 20, fondo 20
     movil ........ derecha 16, fondo calc(80px + env(safe-area-inset-bottom))

   Ese env() es el hueco de la barra de gestos del iPhone, unos 34. Por
   eso en el movil de verdad WhatsApp salia 34 mas arriba que este boton
   aunque los dos dijeran 80, y en escritorio salia 60 mas abajo.

   Aqui va lo mismo, en espejo, valor por valor:

                    WhatsApp          Subir
     tamano ......  46 x 46           46 x 46
     forma .......  radio 999         radio 999
     fondo .......  blanco            blanco
     borde .......  1px #0B0C0D       1px #0B0C0D
     sombra ......  ninguna           ninguna
     icono .......  20 x 20           20 x 20
     al pasar ....  fondo negro,      fondo negro,
                    icono blanco      icono blanco
     escritorio ..  der 20, fondo 20  izq 20, fondo 20
     movil .......  der 16, fondo     izq 16, fondo
                    80 + safe-area    80 + safe-area

   Lo unico que los diferencia es el z-index: WhatsApp 9998 y este 9997,
   asi que si algun dia se cruzan manda WhatsApp.

   EL HOVER, SOLO CON RATON. En una pantalla tactil no hay puntero: el
   navegador aplica :hover al tocar y lo deja puesto hasta que se toca
   en otro sitio, asi que el circulo se quedaba negro despues de
   pulsarlo, como si estuviera seleccionado. Le paso al de WhatsApp y
   este lo heredo al copiarle el aspecto. La regla va dentro de
   @media (hover: hover), que solo cumplen los dispositivos con puntero.
   El de WhatsApp se arregla en ms-linea5.css, correccion 15, porque
   sus estilos no viven en este archivo.

   El archivo se pinta a si mismo: mete su hoja y su boton en la pagina.
   Se hace asi, y no con una seccion, porque tiene que salir en la home,
   en el advertorial y en las dos fichas, y una seccion habria que
   colocarla cuatro veces a mano.

   DOS CONVIVENCIAS QUE HAY QUE RESPETAR
   · La barra de compra de las fichas aparece abajo y centrada. Cuando
     esta visible, este boton sube 96, igual que hace WhatsApp en
     ms-barra-compra.css.
   · Con el menu movil abierto desaparece, tambien igual que WhatsApp.

   NADA DE ANIMACION CONTINUA: solo una transicion de aparicion de
   180ms. Y si el navegador pide menos movimiento, el salto arriba es
   instantaneo en vez de suave.

   EL UMBRAL son 700, el centro de la horquilla que pidio.
*/
(function () {
  'use strict';
  if (window.msSubir) return;
  window.msSubir = true;

  var UMBRAL = 700;

  var CSS = [
    '.ms-subir{',
    'position:fixed;left:20px;bottom:20px;z-index:9997;',
    'width:46px;height:46px;padding:0;margin:0;',
    'display:inline-flex;align-items:center;justify-content:center;',
    'border:1px solid #0B0C0D;border-radius:999px;',
    'background:#ffffff;color:#0B0C0D;cursor:pointer;',
    'box-shadow:none;',
    'opacity:0;visibility:hidden;',
    'transition:opacity 180ms ease, visibility 180ms ease, transform 180ms ease,',
    ' background-color 220ms cubic-bezier(.22,.61,.36,1), color 220ms cubic-bezier(.22,.61,.36,1);',
    '}',
    '.ms-subir[data-ms-ver="1"]{opacity:1;visibility:visible;}',
    '.ms-subir:focus-visible{outline:2px solid #000000;outline-offset:3px;}',
    '.ms-subir svg{display:block;width:20px;height:20px;}',
    /* el hover solo donde hay raton: en tactil se quedaba pegado */
    '@media (hover: hover) and (pointer: fine){',
    '.ms-subir:hover{background:#0B0C0D;color:#ffffff;}',
    '}',
    /* misma esquina y misma altura que WhatsApp en movil, hueco de gestos incluido */
    '@media screen and (max-width:749px){',
    '.ms-subir{left:16px;bottom:calc(80px + env(safe-area-inset-bottom));}',
    '}',
    /* la barra de compra ocupa el bajo de la pantalla: el boton se aparta */
    'body:has(.sticky-add-to-cart__bar[data-ms-visible="1"]) .ms-subir[data-ms-ver="1"]{transform:translateY(-96px);}',
    /* con el menu movil abierto, fuera */
    '@media screen and (max-width:989px){',
    'body:has(.menu-drawer-container.menu-open) .ms-subir{display:none;}',
    '}',
    '@media (prefers-reduced-motion: reduce){',
    '.ms-subir{transition:none;}',
    '}'
  ].join('');

  var FLECHA =
    '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M8 13.5V2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '<path d="M3.2 7.3L8 2.5l4.8 4.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function suave() {
    return !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function montar() {
    if (document.querySelector('.ms-subir')) return;

    var hoja = document.createElement('style');
    hoja.textContent = CSS;
    document.head.appendChild(hoja);

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'ms-subir';
    boton.setAttribute('aria-label', 'Volver arriba');
    boton.innerHTML = FLECHA;

    boton.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: suave() ? 'smooth' : 'auto' });
    });

    document.body.appendChild(boton);

    var pintado = false;
    function mirar() {
      var ver = window.scrollY > UMBRAL;
      if (ver === pintado) return;
      pintado = ver;
      boton.setAttribute('data-ms-ver', ver ? '1' : '0');
    }

    window.addEventListener('scroll', mirar, { passive: true });
    mirar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montar);
  } else {
    montar();
  }
})();